export default {
	colors: {
		color1: '#ffc908',
		color2: '#eb3472',
		textColor: '#eb3472'
	},
	software: {
		installed: [
			{
				id: 1,
				name: "Adobe Flash player",
				icon: "software.flash",
				url: "https://www.adobe.com/products/flashplayer.html",
				description: "The Adobe Flash Player runtime lets you effortlessly reach over 1.3 billion people across browsers and OS versions with no install — 11 times more people than the best-selling hardware game console."
			},
			{
				id: 2,
				name: "Bandizip",
				icon: "software.bandizip",
				url: "http://en.bandisoft.com/bandizip/",
				description: "All-inclusive compression/decompression/browsing/editing Archiver"
			},
			{
				id: 3,
				name: "CylancePROTECT antivirus",
				icon: "software.cylanceProtect",
				url: "https://www.cylance.com/products-protect",
				description: "Artificial Intelligence Endpoint Security. Ransomware, advanced threats, fileless malware and malicious documents are no match for the power of artificial intelligence."
			},
			{
				id: 4,
				name: "FileZilla",
				icon: "software.filezilla",
				url: "https://filezilla-project.org/",
				description: "The free FTP solution. The FileZilla Client not only supports FTP, but also FTP over TLS (FTPS) and SFTP. It is open source software distributed free of charge under the terms of the GNU General Public License."
			},
			{
				id: 5,
				name: "Firefox",
				icon: "software.firefox",
				url: "https://www.mozilla.org/en-US/firefox/",
				description: "Web browser"
			},
			{
				id: 6,
				name: "Java",
				icon: "software.javaLogo",
				url: "https://www.java.com/en/",
				description: "Java powers our digital world. Java is at the heart of our digital lifestyle. It's the platform for launching careers, exploring human-to-digital interfaces, architecting the world's best applications, and unlocking innovation everywhere—from garages to global organizations."
			},
			{
				id: 7,
				name: "KeePass",
				icon: "software.keepass",
				url: "https://keepass.info/",
				description: "KeePass is a free open source password manager, which helps you to manage your passwords in a secure way."
			},
			{
				id: 8,
				name: "Microsoft Office 365",
				icon: "software.office",
				url: "https://portal.office.com",
				description: "It's the apps you know and love. Word, Excel, PowerPoint, Outlook, OneNote, OneDrive—and on your PC, Publisher and Access. Everything you need for home, school, and work."
			},
			{
				id: 9,
				name: "Notepad++",
				icon: "software.notepadPlusPlus",
				url: "https://notepad-plus-plus.org/",
				description: "Notepad++ is a free (as in \"free speech\" and also as in \"free beer\") source code editor and Notepad replacement that supports several languages."
			},
			{
				id: 10,
				name: "Paint.NET",
				icon: "software.paint",
				url: "https://www.getpaint.net/",
				description: "Paint.NET is image and photo editing software for PCs that run Windows."
			},
			{
				id: 11,
				name: "VLC media player",
				icon: "software.vlc",
				url: "https://www.videolan.org/index.html",
				description: "VLC is a free and open source cross-platform multimedia player and framework that plays most multimedia files as well as DVDs, Audio CDs, VCDs, and various streaming protocols."
			},
			{
				id: 12,
				name: "Adobe Creative Cloud",
				icon: "software.creativeCloud",
				url: "https://www.adobe.com/creativecloud.html",
				"note": "Specific to employee's role",
				description: "Creative Cloud gives you the entire collection of Adobe desktop and mobile apps, from essentials like Photoshop CC to next generation tools like Adobe XD CC. You also get built-in templates to jump-start your designs and step-by-step tutorials to sharpen your skills and get up to speed quickly. It’s everything you need to create, collaborate, and get inspired."
			},
			{
				id: 13,
				name: "MS Project",
				icon: "software.msProject",
				url: "https://products.office.com/en-us/project/project-and-portfolio-management-software",
				"note": "Specific to employee's role",
				description: "Streamline project, resource, and portfolio management with Microsoft Project to help you keep track of projects and stay organized."
			}
		],
		canPush: [
			{
				id: 14,
				name: "Audacity",
				icon: "software.audacity",
				url: "https://www.audacityteam.org/",
				description: "Audacity is an easy-to-use, multi-track audio editor and recorder for Windows, Mac OS X, GNU/Linux and other operating systems."
			},
			{
				id: 15,
				name: "Colectica for Excel",
				icon: "software.colectica",
				url: "https://www.colectica.com/colecticaforexcel/",
				description: "Colectica for Microsoft Excel Standard Edition is a free tool to document your spreadsheet data using the open standard for data documentation."
			},
			{
				id: 16,
				name: "FreeFileSync",
				icon: "software.freeFileSync",
				url: "https://freefilesync.org/",
				description: "FreeFileSync is a folder comparison and synchronization software that creates and manages backup copies of all your important files. Instead of copying every file every time, FreeFileSync determines the differences between a source and a target folder and transfers only the minimum amount of data needed."
			},
			{
				id: 17,
				name: "grepWin",
				icon: "software.grepWin",
				url: "https://tools.stefankueng.com/grepWin.html",
				description: "grepWin is a simple search and replace tool which can use regular expressions to do its job. This allows to do much more powerful searches and replaces."
			},
			{
				id: 18,
				name: "InstallRoot",
				icon: "software.installRoot",
				url: "https://militarycac.com/dodcerts.htm",
				"note": "DoD root certificates",
				description: "InstallRoot automates the install of the DoD certificates onto your Windows computer"
			},
			{
				id: 19,
				name: "TortoiseSVN",
				icon: "software.tortoise",
				url: "https://tortoisesvn.net/",
				description: "TortoiseSVN is an Apache Subversion (SVN) client, implemented as a Windows shell extension. It's intuitive and easy to use, since it doesn't require the Subversion command line client to run."
			},
			{
				id: 20,
				name: "Twine",
				icon: "software.twine",
				url: "http://twinery.org/",
				description: "You don't need to write any code to create a simple story with Twine, but you can extend your stories with variables, conditional logic, images, CSS, and JavaScript when you're ready."
			},
			{
				id: 21,
				name: "Unity",
				icon: "software.unity",
				url: "https://unity3d.com/",
				description: "More than an engine, Unity offers everything you need to build beautiful and engaging content, boost your productivity, and connect with your audience."
			}
		],
		download: [
			{
				id: 22,
				name: "Citrix Receiver",
				icon: "software.citrix",
				url: "https://www.citrix.com/products/receiver/",
				description: "Citrix Receiver is the easy-to-install client software that provides access to your XenDesktop and XenApp installations. With this free download you can access applications, desktops and data easily and securely from any device, including smartphones, tablets, PCs and Macs."
			},
			{
				id: 23,
				name: "DBeaver",
				icon: "software.dbeaver",
				url: "https://dbeaver.io/",
				description: "Free multi-platform database tool for developers, SQL programmers, database administrators and analysts."
			},
			{
				id: 24,
				name: "GlassFish",
				icon: "software.glassfish",
				url: "https://javaee.github.io/glassfish/",
				description: "GlassFish is the Open Source Java EE Reference Implementation; as such, we welcome external contributions."
			},
			{
				id: 25,
				name: "Google Chrome",
				icon: "software.chrome",
				url: "https://www.google.com/chrome/",
				description: "One fast, simple, and secure browser for all your devices."
			},
			{
				id: 26,
				name: "NetBeans",
				icon: "software.netbeans",
				url: "https://netbeans.org/",
				description: "Quickly and easily develop desktop, mobile and web applications with Java, JavaScript, HTML5, PHP, C/C++ and more."
			},
			{
				id: 27,
				name: "PuTTY",
				icon: "software.putty",
				url: "https://www.putty.org/",
				description: "PuTTY is a free implementation of SSH and Telnet for Windows and Unix platforms, along with an xterm terminal emulator."
			},
			{
				id: 28,
				name: "R & R Studio",
				icon: "software.rStudio",
				url: "https://www.rstudio.com/",
				description: "RStudio makes R easier to use. It includes a code editor, debugging & visualization tools."
			},
			{
				id: 29,
				name: "Steam",
				icon: "software.steam",
				url: "https://store.steampowered.com/",
				"note": "Including software installed through Steam",
				description: "The ultimate entertainment platform. Play, connect, create and more. Install Steam today and start gaming!"
			},
			{
				id: 30,
				name: "Adobe Connect",
				icon: "software.adobeConnect",
				url: "https://www.adobe.com/products/adobeconnect.html",
				description: "Adobe Connect empowers you to create exceptional digital training, webinar, and collaboration experiences."
			},
			{
				id: 31,
				name: "GoToMeeting",
				icon: "software.gotoMeeting",
				url: "https://www.gotomeeting.com/",
				description: "Designed for success. Built for business. Professional meetings deserve a professional online meeting software. That's GoToMeeting - simple, reliable and effective."
			},
			{
				id: 32,
				name: "WebEx",
				icon: "software.webex",
				url: "https://www.webex.com/",
				description: "From meeting, to brainstorming, to sharing with the whole team, work progresses with Webex. It’s how millions do their best teamwork."
			},
			{
				id: 33,
				name: "XAMPP",
				icon: "software.xampp",
				url: "https://www.apachefriends.org/index.html",
				"note": "Uncheck everything during the install except Apache, MySQL, PHP, and phpMyAdmin",
				description: "XAMPP is a completely free, easy to install Apache distribution containing MariaDB, PHP, and Perl."
			}
		]
	},
	quickFacts: [
		{
			id: 1,
			side1: "Suspicious Emails",
			side2: "<p>If you are at all concerned or suspicious about an email or attachment, don't open it! Michael will be happy to double-check it for validity.</p>",
			icon: "it.suspiciousEmails"
		},{
			id: 2,
			side1: "Protecting Your Password",
			side2: "<p>Creating and managing passwords can be frustrating and difficult.  We have tools to help make it easier, though.  Check out our <a href=\"https://www.youtube.com/watch?v=ntuogRkm0z8\" target=\"_blank\" rel=\"noopener noreferrer\">KeePass video</a> for more details.  Sharing passwords with others is usually a license violation, so don’t do it without checking with Michael.</p>",
			icon: "it.password"
		},{
			id: 3,
			side1: "Downloading and Installing Software",
			side2: "<p>Always check with Michael Magill first before downloading or installing any programs. He will quickly verify the safety of the software and that we won't violate the license by using it.</p>",
			icon: "it.download"
		},{
			id: 4,
			side1: "Office 365",
			side2: "<p>All employees have an Office 365 subscription, which includes access to the online versions of Microsoft Office from anywhere. The subscription also includes 1TB of OneDrive cloud storage, which may be used for saving and sharing IDSI data.</p>",
			icon: "it.office365"
		},{
			id: 5,
			side1: "Proper Folder Etiquette",
			side2: "<p>IDSI employees have a personal folder at R:\\Users. For sensitive files, there is a private folder inside your personal folder that only you can access. Project files should go in the appropriate R:\\Projects folder.</p>",
			icon: "it.folderEtiquette"
		},{
			id: 6,
			side1: "Leaving Your IDSI Computer On",
			side2: "<p>When your IDSI computer is in an IDSI office, it should be left on at all times, including nights and weekends.  Feel free to lock, log off, or reboot when you leave, but don’t shut down or put it to sleep.  This allows it to keep everything up-to-date without interrupting you. This doesn't apply when it is out of the office.</p>",
			icon: "it.computerOn"
		},{
			id: 7,
			side1: "Copyrighted Media on the Server",
			side2: "<p>Copyrighted media is almost always licensed to you specifically, and putting it on a shared platform is illegal.</p><p>Do not put any pirated, stolen, or illegal content on <em>any</em> IDSI computer or device.</p>",
			icon: "it.copyrightedMedia"
		},{
			id: 8,
			side1: "Overworking the Server",
			side2: "<p>If a lot of files are put on the server at once, it can back up the real-time sync, so people collaborating between offices can't see each other's changes. Coordinate with Michael if you need to place a large amount of data on the server.</p>",
			icon: "it.overworkingServer"
		}
	],
	referenceVideos: [
		{
			id: 1,
			title: "Timesheets & Expenses",
			thumbnail: "video-thumbnail-timesheets",
			url: "https://www.youtube.com/watch?v=SL4ZcE-5QG0"
		},
		{
			id: 2,
			title: "Mattermost",
			thumbnail: "video-thumbnail-mattermost",
			url: "https://www.youtube.com/watch?v=kJDkdCBrPnU"
		},
		{
			id: 3,
			title: "KeePass",
			thumbnail: "video-thumbnail-keepass",
			url: "https://www.youtube.com/watch?v=ntuogRkm0z8"
		},
		{
			id: 4,
			title: "Remote Access",
			thumbnail: "video-thumbnail-remote",
			url: "https://www.youtube.com/watch?v=2HGIAuhCH2o"
		}
	],
	docs: [
		{
			id: 1,
			title: "Approved Software List",
			link: "assets/docs/Pre-Approved-Software.pdf"
		}
	]
};



// WEBPACK FOOTER //
// ./src/data/IT.js